import { __assign, __extends } from "tslib";
import React from 'react';
import Input from './Input';
import { classes, st } from './Input.st.css';
import DATA_ATTR from './DataAttr';
import { filterObject } from '../utils/filterObject';
import { WixStyleReactDefaultsOverrideContext } from '../WixStyleReactDefaultsOverrideProvider';
var ThemedInput = /** @class */ (function (_super) {
    __extends(ThemedInput, _super);
    function ThemedInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // For testing purposes only
        _this._getDataAttr = function () {
            var _a;
            var inputPropsDefaults = _this.context.input;
            var _b = _this.props, _c = _b.size, size = _c === void 0 ? inputPropsDefaults.size : _c, status = _b.status, prefix = _b.prefix, disabled = _b.disabled, forceHover = _b.forceHover, forceFocus = _b.forceFocus, noLeftBorderRadius = _b.noLeftBorderRadius, noRightBorderRadius = _b.noRightBorderRadius;
            return filterObject((_a = {},
                _a[DATA_ATTR.SIZE] = size,
                _a[DATA_ATTR.STATUS] = status,
                _a[DATA_ATTR.PREFIX] = !!prefix,
                _a[DATA_ATTR.DISABLED] = !!disabled,
                _a[DATA_ATTR.HOVER] = !!forceHover,
                _a[DATA_ATTR.FOCUS] = !!(forceFocus || _this.state.focus),
                _a[DATA_ATTR.LEFTBORDERRADIUS] = !!noLeftBorderRadius,
                _a[DATA_ATTR.RIGHTBORDERRADIUS] = !!noRightBorderRadius,
                _a), function (key, value) { return !!value; });
        };
        return _this;
    }
    ThemedInput.prototype.render = function () {
        var inputPropsDefaults = this.context.input;
        var _a = this.props, _b = _a.size, size = _b === void 0 ? inputPropsDefaults.size : _b, dataHook = _a.dataHook, rtl = _a.rtl, status = _a.status, disabled = _a.disabled, forceHover = _a.forceHover, forceFocus = _a.forceFocus, border = _a.border, className = _a.className, noLeftBorderRadius = _a.noLeftBorderRadius, noRightBorderRadius = _a.noRightBorderRadius, readOnly = _a.readOnly;
        var placeholder = this.props.placeholder;
        return (React.createElement("div", __assign({ className: st(classes.root, {
                size: size,
                hasFocus: forceFocus || this.state.focus,
                status: status,
                forceHover: forceHover,
                readOnly: readOnly,
                disabled: disabled,
                border: border,
                noRightBorderRadius: noRightBorderRadius,
                noLeftBorderRadius: noLeftBorderRadius,
            }, className), dir: rtl ? 'rtl' : null, "data-hook": dataHook }, this._getDataAttr()), _super.prototype.render.call(this, { placeholder: placeholder })));
    };
    ThemedInput.contextType = WixStyleReactDefaultsOverrideContext;
    return ThemedInput;
}(Input));
ThemedInput.propTypes = __assign({}, Input.propTypes);
export default ThemedInput;
//# sourceMappingURL=ThemedInput.js.map